export const API_URLS = {
  UPDATE_ZIP_CODE: '/v2/api/sitecore/Header/UpdateZipCode',
  GET_PREFERRED_ZIPCODE: '/v2/api/sitecore/Header/GetPreferredUserZipCode',
  LOCATE_ME_RENDERING: '/v2/api/sitecore/Header/LocateMeRendering',
  VALIDATE_ZIPCODE: '/v2/api/sitecore/Header/ValidateZipCode',
  BING: '//dev.virtualearth.net/REST/v1/Locations/',
  LOCAL: 'https://www6.qaautonation.com' //'http://local.autonation.com'
};

export const KEYS = {
  BING_MAPS: ''
}

export const CONSTANTS = {
  ELEMENT_NAME: 'popover-element',
  CLASS_SELECTOR: '.dt-an-zipcode-popover-container',

  VERIFY_ELEMENT_NAME: 'verify-zipcode-modal-element',
  ROADSTER_ZIPCODE_CHANGED: '__ROADSTER__ZIPCODE__CHANGED__',
  UPDATE_ZIPCODE_EVENT: '__UPDATE__ZIPCODE__HEADER__V2__EVENT__'
}
